import { StaffExtendedDto, WbsListDto, WbsPlanningDto } from '@api/client';
import { useAppDispatch } from 'core/store/hooks';
import { deleteWbsProjectPlanningById } from 'pages/private/_redux/planning/actions';

const useWbsManagement = (
  deliverablesTableData: WbsListDto[] | undefined,
  setDeliverablesTableData: React.Dispatch<React.SetStateAction<WbsListDto[] | undefined>>,
  filterAllocationsByYear: (year: number | 'all', allocations: WbsListDto[] | undefined) => void,
  currentYear: number | 'all',
  setTotalForecastDeliverables: React.Dispatch<React.SetStateAction<number[]>>,
  fullAllocations: Partial<StaffExtendedDto>[] | null | undefined,
  projectId: number
) => {
  const dispatch = useAppDispatch();

  const handleChangeAllocation = (value: number | null, id: number | undefined) => {
    const newAllocations = deliverablesTableData?.map((el) => ({
      ...el,
      wbsPlanningDtoList: el.wbsPlanningDtoList?.map((el) => ({
        ...el,
        corrispettivo: el.id === id ? Number(value) : el.corrispettivo,
      })),
    }));
    setDeliverablesTableData(newAllocations);
    filterAllocationsByYear(currentYear, newAllocations);
  };

  const handleChangeWbsField = (value: string | number | null, index: number, field: keyof WbsListDto) => {
    let newAllocations = deliverablesTableData?.map((el, i) => ({
      ...el,
      [field]: i === index ? value ?? '' : el[field],
    }));
    // if (field === 'pesoAttivita' && !value) {
    //   // azzero tutti i corrispettivo
    //   newAllocations = newAllocations?.map((el) => ({
    //     ...el,
    //     wbsPlanningDtoList: el.wbsPlanningDtoList?.map((el) => ({
    //       ...el,
    //       corrispettivo: 0,
    //     })),
    //   }));
    // }
    setDeliverablesTableData(newAllocations);
    filterAllocationsByYear(currentYear, newAllocations);
  };

  const handleChangeTotalForecastDeliverables = (value: number | null, index: number) => {
    setTotalForecastDeliverables((prev) => {
      const newTotalForecastDeliverables = [...prev];
      newTotalForecastDeliverables[index] = value ?? 0;
      return newTotalForecastDeliverables;
    });
  };

  const addDeliverable = () => {
    let currentId = -Math.floor(Math.random() * 100000);
    const newAllocations: WbsListDto[] = [
      ...(deliverablesTableData ?? []),
      {
        id: currentId,
        titolo: undefined,
        pesoAttivita: undefined,
        projectId,
        corrispettivoEconomico: undefined,
        wbsPlanningDtoList: createAllocationsForNewDeliverable(currentId),
      },
    ];
    setDeliverablesTableData(newAllocations);
    filterAllocationsByYear(currentYear, newAllocations);
  };

  const createAllocationsForNewDeliverable = (currentId: number): WbsPlanningDto[] | undefined => {
    if (deliverablesTableData?.length) {
      return deliverablesTableData?.[0]?.wbsPlanningDtoList?.map((el) => ({
        id: currentId--,
        mese: el.mese,
        anno: el.anno,
        corrispettivo: 0,
        enable: el.enable,
      }));
    }
    return fullAllocations?.[0]?.allocazioni?.map((el) => ({
      id: currentId--,
      mese: el.month,
      anno: el.year,
      corrispettivo: 0,
      enable: el.editEnable,
    }));
  };

  const deleteDeliverable = (index: number, wbsId: number | undefined) => {
    const row = deliverablesTableData?.[index];
    if (row && row.wbsPlanningDtoList?.filter((del) => !del.enable)?.every((el) => !el.corrispettivo)) {
      if (row.wbsPlanningDtoList?.every((el) => el.id && el.id < 0)) {
        const newCostData = deliverablesTableData?.filter((_, i) => i !== index) || [];
        setDeliverablesTableData(newCostData);
        filterAllocationsByYear(currentYear, newCostData);
      } else {
        if (!wbsId) return;
        dispatch(deleteWbsProjectPlanningById(wbsId)).then((response) => {
          if (response) {
            const newCostData = deliverablesTableData?.filter((_, i) => i !== index) || [];
            setDeliverablesTableData(newCostData);
            filterAllocationsByYear(currentYear, newCostData);
          }
        });
      }
    }
  };

  const clearForecastAmounts = (index: number) => {
    let newFullAllocations = deliverablesTableData?.map((el) => {
      if (el.wbsPlanningDtoList?.[0].id === deliverablesTableData?.[index].wbsPlanningDtoList?.[0].id) {
        return {
          ...el,
          wbsPlanningDtoList: el.wbsPlanningDtoList?.map((el) => {
            if (el.enable) {
              return {
                ...el,
                corrispettivo: 0,
              };
            }
            return el;
          }),
        };
      }
      return el;
    });
    setDeliverablesTableData(newFullAllocations);
    filterAllocationsByYear(currentYear, newFullAllocations);
  };

  return {
    handleChangeWbsField,
    handleChangeAllocation,
    handleChangeTotalForecastDeliverables,
    addDeliverable,
    deleteDeliverable,
    clearForecastAmounts,
  };
};

export default useWbsManagement;
